import Vue from 'vue'

import { YouTubePlayer } from 'vue-youtube-embed'

import VIcon from '@/components/core/VIcon'
import VRadio from '@/components/core/VRadio'
import Accordion from '@/components/Accordion'
import VButton from '@/components/core/VButton'
import AccordionItem from '@/components/AccordionItem'
import RoundAvatar from '@/components/core/RoundAvatar'
import FancyHeading from '@/components/core/FancyHeading'
import VideoSection from '@/components/core/VideoSection'
import LightGallery from '@/components/core/LightGallery'
import TopPageTitle from '@/components/core/TopPageTitle'
import CardComponent from '@/components/core/CardComponent'
import TopPageSection from '@/components/core/TopPageSection'
import BackgroundSection from '@/components/core/BackgroundSection'
import AngleSection from '@/components/core/AngleSection'
import CenteredCardLayout from '@/views/layouts/CenteredCardLayout'
import VIncrement from '@/components/core/VIncrement'
import WinnerSection from '@/components/WinnerSection'
import MileageInput from '@/components/core/MileageInput'
import RunnerUpsTable from '@/components/RunnerUpsTable'
import TicketsTable from '@/components/TicketsTable'
import TicketsTableEditable from '@/components/TicketsTableEditable'

Vue.component('VButton', VButton)
Vue.component('Accordion', Accordion)
Vue.component('FancyHeading', FancyHeading)
Vue.component('VideoSection', VideoSection)
Vue.component('TopPageTitle', TopPageTitle)
Vue.component('TopPageSection', TopPageSection)
Vue.component('AngleSection', AngleSection)
Vue.component('CardComponent', CardComponent)
Vue.component('AccordionItem', AccordionItem)
Vue.component('YouTubePlayer', YouTubePlayer)
Vue.component('VIcon', VIcon)
Vue.component('VRadio', VRadio)
Vue.component('RoundAvatar', RoundAvatar)
Vue.component('BackgroundSection', BackgroundSection)
Vue.component('LightGallery', LightGallery)
Vue.component('CenteredCardLayout', CenteredCardLayout)
Vue.component('VIncrement', VIncrement)
Vue.component('WinnerSection', WinnerSection)
Vue.component('MileageInput', MileageInput)
Vue.component('RunnerUpsTable', RunnerUpsTable)
Vue.component('TicketsTable', TicketsTable)
Vue.component('TicketsTableEditable', TicketsTableEditable)
